export default {
  resetPassword: 'Resetear contraseña',
  ready: 'Las instrucciones fueron enviadas a tu correo electrónico'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/forgot/es.js